module.exports = __webpack_public_path__ + "static/japanese-encephalitis-29eb29a17c94f28b451e6892f1c3c58f.png";